export default __webpack_public_path__ + "static/media/onboarding_gifts_3.94bcb00a.svg";